import { styled } from "styled-components";

export const TopBarWrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 6px;
  background: ${({ theme }) => theme.colors.default[100]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.default[200]};
`;

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex: 1;
  align-items: center;
  gap: 12px;
`;

export const SwitchWrapper = styled.div``;
